<template>
	<div class="form-socials">
		<div class="form-socialsList" v-if="items.length">
			<div class="form-socialsListItem" v-for="item in items" :key="item.plugin_title">
				<a
					class="button2 button2_nowrap"
					:target="blankFrame ? '_blank' : false"
					:href="getLink(item.link)"
					:rel="noRedirect ? 'noreferrer noopener' : false"
				>
					<span>Вход через {{ titles[item.plugin_title] }}</span>
					<svg
						class="icon icon-social icon-social_fb"
						enable-background="new 0 0 24 24"
						height="512"
						viewBox="0 0 24 24"
						width="512"
						xmlns="http://www.w3.org/2000/svg"
						v-if="item.plugin_name === 'facebook'"
					>
						<path
							d="m21 0h-18c-1.655 0-3 1.345-3 3v18c0 1.654 1.345 3 3 3h18c1.654 0 3-1.346 3-3v-18c0-1.655-1.346-3-3-3z"
							fill="#3b5999"
						/>
						<path
							d="m16.5 12v-3c0-.828.672-.75 1.5-.75h1.5v-3.75h-3c-2.486 0-4.5 2.014-4.5 4.5v3h-3v3.75h3v8.25h4.5v-8.25h2.25l1.5-3.75z"
							fill="#fff"
						/>
					</svg>
					<svg
						class="icon icon-social icon-social_gl"
						viewBox="0 0 256 262"
						xmlns="http://www.w3.org/2000/svg"
						preserveAspectRatio="xMidYMid"
						v-if="item.plugin_name === 'google'"
					>
						<path
							d="M255.878 133.451c0-10.734-.871-18.567-2.756-26.69H130.55v48.448h71.947c-1.45 12.04-9.283 30.172-26.69 42.356l-.244 1.622 38.755 30.023 2.685.268c24.659-22.774 38.875-56.282 38.875-96.027"
							fill="#4285F4"
						/>
						<path
							d="M130.55 261.1c35.248 0 64.839-11.605 86.453-31.622l-41.196-31.913c-11.024 7.688-25.82 13.055-45.257 13.055-34.523 0-63.824-22.773-74.269-54.25l-1.531.13-40.298 31.187-.527 1.465C35.393 231.798 79.49 261.1 130.55 261.1"
							fill="#34A853"
						/>
						<path
							d="M56.281 156.37c-2.756-8.123-4.351-16.827-4.351-25.82 0-8.994 1.595-17.697 4.206-25.82l-.073-1.73L15.26 71.312l-1.335.635C5.077 89.644 0 109.517 0 130.55s5.077 40.905 13.925 58.602l42.356-32.782"
							fill="#FBBC05"
						/>
						<path
							d="M130.55 50.479c24.514 0 41.05 10.589 50.479 19.438l36.844-35.974C195.245 12.91 165.798 0 130.55 0 79.49 0 35.393 29.301 13.925 71.947l42.211 32.783c10.59-31.477 39.891-54.251 74.414-54.251"
							fill="#EB4335"
						/>
					</svg>
				</a>
			</div>
			<div class="form-socialsListItem" v-if="im">
				<nuxt-link
					class="button2 button2_nowrap"
					to="/profile/login/telegram"
					:target="blankFrame ? '_blank' : false"
					:rel="noRedirect ? 'noreferrer noopener' : false"
				>
					<span>Вход через Telegram</span>
					<svg class="icon icon-social icon-social_fb" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
						<path d="M15 30C23.2843 30 30 23.2843 30 15C30 6.71573 23.2843 0 15 0C6.71573 0 0 6.71573 0 15C0 23.2843 6.71573 30 15 30Z" fill="#229AD6"/>
						<path fill-rule="evenodd" clip-rule="evenodd" d="M6.86519 14.667C11.1818 12.7702 14.06 11.5197 15.4998 10.9153C19.6121 9.1912 20.471 8.89178 21.0234 8.88064C21.2282 8.87663 21.4291 8.93751 21.5978 9.05472C21.7162 9.15767 21.7917 9.30191 21.8091 9.45858C21.8388 9.65342 21.8472 9.85098 21.8339 10.0477C21.6116 12.4151 20.6464 18.1374 20.1562 20.782C19.949 21.8961 19.5403 22.2763 19.144 22.3139C18.2851 22.3932 17.625 21.7401 16.7965 21.19C15.4929 20.328 14.7569 19.7974 13.492 18.9507C12.0297 17.9759 12.9783 17.4453 13.811 16.5735C14.0292 16.3451 17.8156 12.8691 17.8901 12.5544C17.9 12.5079 17.8988 12.4597 17.8868 12.4138C17.8749 12.3678 17.8523 12.3254 17.8211 12.2898C17.7758 12.2612 17.7245 12.2437 17.6712 12.2386C17.618 12.2335 17.5644 12.241 17.5145 12.2605C17.3847 12.2893 15.3033 13.6768 11.2702 16.4231C10.6792 16.8325 10.1439 17.0321 9.66424 17.0219C9.13536 17.0094 8.11903 16.7197 7.3623 16.4649C6.43573 16.1613 5.70525 16.0011 5.76325 15.49C5.79731 15.2226 6.16462 14.9483 6.86519 14.667Z" fill="white"/>
					</svg>
				</nuxt-link>
			</div>
		</div>
	</div>
</template>
<script>
export default {
	props: {
		blankFrame: {
			type: Boolean,
			default: () => false,
		},
		noRedirect: {
			type: Boolean,
			default: () => false,
		},
		im: {
			type: Boolean,
			default: () => false,
		},
	},
	data: () => ({
		titles: {
			COM_SLOGIN_PROVIDER_FACEBOOK: 'Facebook',
			COM_SLOGIN_PROVIDER_GOOGLE: 'Google',
		},
	}),
	created() {
		this.$store.dispatch('api/send', {
			task: 'getSocials',
		});
	},
	computed: {
		items() {
			return this.$store.state.api.socials;
		},
	},
	methods: {
		getLink(link) {
			return (process.env.NODE_ENV !== 'production' ? 'https://dev.mysportexpert.ru/' : '/') + link;
		},
	},
};
</script>
